import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const purchasesApi = createApi({
  reducerPath: 'purchasesApi',
  baseQuery: createBaseQuery('purchases', { timeout: 0 }),
  endpoints: builder => ({
    getPurchases: builder.query({
      query: () => '/',
      transformResponse: ({ result }) => result,
    }),
    createPurchase: builder.mutation({
      query: data => ({
        url: '/',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useGetPurchasesQuery, useCreatePurchaseMutation } = purchasesApi;
